/**
 *
 */
export class DownloadImageError extends Error {
    declare cause: DownloadImageErrorCause
    constructor(cause: DownloadImageErrorCause) {
        super(`Download image failed. Reason: ${cause}`);
        this.name = "DownloadImageError";
        this.cause = cause
    }
}

/**
 *
 */
export enum DownloadImageErrorCause {
    /**
 *
 *
 *
 *
 *
 *
 */
    DownloadFailedHttpCode = 'DOWNLOAD_FAILED_HTTP_XXX',
    /**
 *
 *
 *
 *
 */
    DownloadFailedTimeout = 'DOWNLOAD_FAILED_TIMEOUT',
    /**
 *
 *
 *
 *
 *
 *
 */
    DownloadFailedUnknownError = 'DOWNLOAD_FAILED_UNKNOWN_ERROR',
    /**
 *
 *
 *
 *
 *
 *
 *
 */
    FeatureNotSupported = 'FEATURE_NOT_SUPPORTED',
    /**
 *
 *
 *
 *
 *
 *
 *
 */
    IllegalContent = 'ILLEGAL_CONTENT',
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    PermissionDenied = 'PERMISSION_DENIED',
    /**
 *
 *
 *
 *
 *
 */
    SaveToPhotoLibraryError = 'SAVE_TO_PHOTO_LIBRARY_ERROR',
    /**
 *
 *
 *
 *
 */
    Unknown = 'UNKNOWN',
    /**
 *
 *
 *
 *
 *
 */
    UrlInvalid = 'URL_INVALID'
}

export const parseDownloadImageErrorCause = function(errorCode: string | undefined): DownloadImageErrorCause {
    if (!errorCode) return DownloadImageErrorCause.Unknown;
    if (errorCode.startsWith("DOWNLOAD_FAILED_HTTP_")) {
        return DownloadImageErrorCause.DownloadFailedHttpCode;
    }

    const uncheckedErrorCode = errorCode as DownloadImageErrorCause;
    return Object.values(DownloadImageErrorCause).includes(uncheckedErrorCode)
        ? uncheckedErrorCode
        : DownloadImageErrorCause.Unknown;
}
